import {http} from '@/utils/http'
import {ICountFilter} from "@/types/main";
import {cleanParams} from "@/utils/cleanParams";

export const statsService = {
    getCounts(filter: ICountFilter) {
        return http.get('/stats/counts', {
            params: cleanParams(filter)
        })
    },
}